'use client';

import { useTranslations } from 'next-intl';

import { Button, Link } from '@/components/atoms';
import { cn } from '@/lib/utils/tailwind';

type CookiesButtonProps = {
  variant?: 'default' | 'link';
};

const CookiesButton = ({ variant = 'default' }: CookiesButtonProps) => {
  const t = useTranslations();
  const handleClick = () => {
    if (window.axeptioSDK) {
      window.axeptioSDK.openCookies();
    } else {
      window._axcb = window._axcb || [];
      window._axcb.push(sdk => sdk?.openCookies());
    }
  };

  if (variant === 'link') {
    return (
      <div
        className={cn(
          'px-(--horizontal-spacing-3)',
          'flex my-0 items-center gap-(--horizontal-spacing-6) whitespace-nowrap',
        )}
      >
        <Link
          href="#"
          size="sm"
          onClick={e => {
            e.preventDefault();
            handleClick();
          }}
        >
          {t('B2B_COOKIES_FOOTER_LINK')}
        </Link>
      </div>
    );
  }

  return (
    <Button variant="secondary" onClick={handleClick} className={cn('py-1')}>
      {t('B2B_COOKIES_FOOTER_LINK')}
    </Button>
  );
};

export { CookiesButton };
